import axiosInstance from "../utils/axiosInstance";

export const getChatWorkersApi = (search = "") =>
  axiosInstance.get("/chat/workers", { params: { search } });
export const getConversationsApi = ({ page = 1, limit = 50 } = {}) =>
  axiosInstance.get("/chat/conversations", { params: { page, limit } });
export const createConversationApi = (participantId) =>
  axiosInstance.post("/chat/conversations", { participantId });
export const getMessagesApi = ({ conversationId, before, limit = 40 }) =>
  axiosInstance.get(`/chat/conversations/${conversationId}/messages`, {
    params: { before, limit },
  });
export const sendMessageApi = (conversationId, payload) =>
  axiosInstance.post(`/chat/conversations/${conversationId}/messages`, payload);
export const markConversationReadApi = (conversationId) =>
  axiosInstance.post(`/chat/conversations/${conversationId}/read`);
export const getChatUnreadCountApi = () => axiosInstance.get("/chat/unread-count");
